import { Link } from "react-router-dom";
import HotListCard from "@/components/feature/HotListCard";
import { siteInfo } from "@/mocks/site";

const stats = [
  { label: "今日新增爆料", value: "128", unit: "条" },
  { label: "实时在线蹲点", value: "4.2", unit: "万" },
  { label: "覆盖栏目", value: "6", unit: "个" },
];

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-300/60">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20night%20city%20bokeh%20with%20amber%20and%20crimson%20glow%20soft%20grain%20moody%20dark%20texture%20with%20wide%20negative%20space%20no%20people%20cinematic&width=1600&height=900&seq=hlwb-hero-01&orientation=landscape"
          alt="夜晚城市灯光氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/40" />
      </div>

      <div className="relative w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-8 lg:gap-12 items-start">
          <div className="max-w-2xl">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
                <span className="relative w-2 h-2 rounded-full bg-primary-500 live-dot" />
                正在实时更新
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-moon-clear-line" aria-hidden="true"></i>
                </span>
                晚间热搜已更新
              </span>
            </div>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight tracking-tight text-foreground-950">
              全网正在聊什么
              <br />
              这里一站看全
            </h1>

            <p className="mt-5 max-w-xl text-sm md:text-base leading-7 text-foreground-700">
              {siteInfo.intro}
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => scrollToId("live")}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-radar-line" aria-hidden="true"></i>
                </span>
                进入实时爆料流
              </button>
              <button
                type="button"
                onClick={() => scrollToId("evening")}
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-400/70 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                </span>
                查看晚间热搜榜
              </button>
            </div>

            <dl className="mt-9 flex flex-wrap gap-x-10 gap-y-5">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-foreground-500">{item.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">
                    {item.value}
                    <span className="ml-1 text-sm font-medium text-foreground-500">{item.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="w-full">
            <HotListCard limit={5} title="今晚热搜榜 · TOP5" />
            <Link
              to="/topics"
              className="mt-3 flex items-center justify-between rounded-lg border border-background-300/60 bg-background-100 px-5 py-4 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="text-sm text-foreground-800">
                想看完整榜单与分类？进入分类专题页
              </span>
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}